<template>
  <div class="search">
    <div class="search__input">
      <input
        type="text"
        v-model="searchParam"
        autocomplete="off"
        :placeholder="I18n.t('auctions_catalogs.auctions_search_placeholder')">
    </div>
    <div class="search__actions">
      <div class="btn-oval btn-oval--orange">
        <span class="icon icon-search"></span>
      </div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      searchParam: '',
    };
  },
  watch: {
    searchParam() {
      this.$emit('changeSearchParam', this.searchParam);
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/search.vue?b030af5e